module.exports = __webpack_public_path__ + "static/media/pol_bg_4.d40d3b12.webp";